// extracted by mini-css-extract-plugin
export default {"loader_overlay":"Loader_loader_overlay__4LDKS","spinner":"Loader_spinner__O2Z7b","up":"Loader_up__5tDKW","down":"Loader_down__peMda"};